import { ChangeEvent, HTMLInputTypeAttribute, useCallback, useContext, useEffect } from 'react'
import _ from 'lodash'
import { ConceptStatus, ConceptStatusValidity, ConceptValueDataType } from "@fusion-advantage/backcompat"
import { Concept, ConceptActivation } from '@fusion-advantage/formlib'
import L1TextField from '../l1/L1TextField'
import { FusionColor } from '../../../theme/FusionStyle'
import L6FormContext from '../l6/L6FormContext'
import { validityIndicatorProps } from '../../uiv2/Indicator/StatusIndicatorProps'
import { useTheme } from '@emotion/react'

interface L3TextFieldProps {
	xpath: string
	concept: Concept
	conceptStatus: ConceptStatus|null
	validity: ConceptStatusValidity|null
	activation: ConceptActivation|null
	onChange: (e: ChangeEvent<HTMLInputElement>) => void
	units: string|null|undefined
}

const L3TextField = ({xpath, concept, conceptStatus, validity, activation, onChange, units}: L3TextFieldProps) => {
	// leave the '' to ensure that
	// L1TextField is always a controlled component
	let value = ''
	if(conceptStatus && conceptStatus.value !== null) {
		value = String(conceptStatus.value)
	}
	const isValued = useCallback(() => {
		return value !== ''
	}, [value])
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	useEffect(() => {
		setXpathValuedDeterminer(xpath, isValued)
		return () => {
			setXpathValuedDeterminer(xpath, false)
		}
	}, [xpath, setXpathValuedDeterminer, isValued])
	let inputType: HTMLInputTypeAttribute = 'text'
	if(concept) {
		switch(concept.valueDataType) {
			case ConceptValueDataType.Decimal:
			case ConceptValueDataType.Integer:
				inputType = 'number'
				break
			case ConceptValueDataType.Date:
				inputType = 'date'
				break
		}
	}
	let borderColor: FusionColor|undefined
	if(validity) {
		const props = validityIndicatorProps(validity)
		borderColor = props.color
	}
	const theme = useTheme()
	return (
		<L1TextField
			inputType={inputType}
			value={value}
			disabled={activation === ConceptActivation.Disabled}
			onChange={onChange}
			units={units}
			borderColor={borderColor}
			// comment for now as these are doubling up the icons
			// provided by TitleLabel
			// tip={err ? <L3ValidationTip error={err} /> : null}
			viewOnly={theme.isPrintMode ? true : false}
		/>
	)
}

export default L3TextField
